export const signupConfirmationPath = "/auth/confirm";
